import React from 'react'
import { Typography } from '@mui/material'
import { useGetOne, useTranslate } from 'react-admin'

interface UserReferenceProps {
  userId?: string
  fallback?: string
}

const UserReference: React.FC<UserReferenceProps> = ({ 
  userId, 
  fallback 
}) => {
  const translate = useTranslate()
  const defaultFallback = fallback || translate('resources.audit.system')
  
  const { data: user, isLoading, error } = useGetOne(
    'users',
    { id: userId },
    { enabled: !!userId }
  )

  if (!userId) {
    return (
      <Typography variant="body2">
        {defaultFallback}
      </Typography>
    )
  }

  if (isLoading) {
    return (
      <Typography variant="body2" color="text.secondary">
        {translate('resources.audit.loading')}
      </Typography>
    )
  }

  if (error || !user) {
    return (
      <Typography variant="body2" color="text.secondary">
        ID: {userId}
      </Typography>
    )
  }

  // Формируем отображаемое имя пользователя
  const displayName = user.name || user.email || user.login || `ID: ${userId}`

  return (
    <Typography variant="body2">
      {displayName}
    </Typography>
  )
}

export default UserReference
